import { useState } from "react";
import { TextInput, TranslatableInputs } from "react-admin";
import { CustomDialog } from "../../customComponents/CustomDialog";
import { CustomButton } from "../../customComponents/CustomButtons";
import { FormControlLabel, FormGroup, Switch, Box } from "@material-ui/core";
import classnames from "classnames";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export const GapWarningDialog = ({ open, onClose, onConfirm, translate }) => {
	return (
		<CustomDialog
			open={open}
			title="surveys.feedbackBrackets.gapWarningTitle"
			content="surveys.feedbackBrackets.gapWarningMessage"
		>
			<Box display="flex" gap={1}>
				<CustomButton
					onClick={onClose}
					innerStyle={{
						display: "flex",
						alignItems: "unset",
						justifyContent: "center",
					}}
					innerText="No"
					icon={<CancelIcon />}
					className={classnames("ra-confirm")}
					color="primary"
				/>
				<CustomButton
					onClick={onConfirm}
					innerStyle={{
						display: "flex",
						alignItems: "unset",
						justifyContent: "center",
					}}
					innerText="Yes"
					icon={<CheckCircleIcon />}
					className={classnames("ra-confirm")}
					color="primary"
				/>
			</Box>
		</CustomDialog>
	);
};

export const CustomBooleanInput = ({
	label,
	color,
	disabled,
	inputRef,
	setIsActive,
	isActive,
	name,
}) => {
	const [open, setOpen] = useState(false);

	const handleClickOpen = (event) => {
		let value = !(event.target.value === "true");
		if (value) setOpen(true);
		else setIsActive(false);
	};

	return (
		<>
			<FormGroup row>
				<FormControlLabel
					control={
						<Switch
							checked={isActive}
							onChange={handleClickOpen}
							name={name}
							color={color || "primary"}
							disabled={disabled}
							value={isActive}
							inputRef={inputRef}
						/>
					}
					label={label}
				/>
			</FormGroup>
			<CustomDialog
				open={open}
				title={"WARNING!"}
				content={
					"Are you sure you want to mark this as an active survey?"
				}
			>
				<CustomButton
					onClick={() => {
						setIsActive(false);
						setOpen(false);
					}}
					innerStyle={{
						display: "flex",
						alignItems: "unset",
						justifyContent: "center",
					}}
					innerText="No"
					icon={<CancelIcon />}
					className={classnames("ra-confirm")}
					color="primary"
					autoFocus
				/>
				<CustomButton
					onClick={() => {
						setIsActive(true);
						setOpen(false);
					}}
					innerStyle={{
						display: "flex",
						alignItems: "unset",
						justifyContent: "center",
					}}
					innerText="Yes"
					icon={<CheckCircleIcon />}
					className={classnames("ra-confirm")}
					color="primary"
					autoFocus
				/>
			</CustomDialog>
		</>
	);
};

export const CustomTranslatableInputs = ({ locales, source, label }) => {
	return (
		<TranslatableInputs locales={locales} defaultLocale="ar(Male)">
			<TextInput source={source} label={label} />
		</TranslatableInputs>
	);
};
